import DiscountCouponService from "../service";
import { router } from "@/router";

export const actions = {
  listDiscountCoupons({ commit }, data) {
    dispatch("enableLoading");

    DiscountCouponService.list()
      .then(res => {
        dispatch("disableLoading");
        commit("setDiscountCoupons", res.data);
      })
      .catch(e => {
        dispatch("disableLoading");
        dispatch("createGlobalMessage", {
          type: "error",
          message: e.response.data.message,
          timeout: 6000
        });
      });
  }
};

export default {};
